import { SET_AVAILABLE_FIELDS, SET_FIELDS, SET_SELECT_ON_MAP } from './constants';

export function setFields(selected: any[]) {
    return {
        type: SET_FIELDS,
        selected,
    };
}

export function setAvailableFields(available: any[]) {
    return {
        type: SET_AVAILABLE_FIELDS,
        available,
    };
}

export function setSelectOnMap(selectOnMap: boolean) {
    return {
        type: SET_SELECT_ON_MAP,
        selectOnMap,
    };
}
